<template>
  <ApiLoading :apiError="true">
    <p>{{ maintenanceModeMessage }}</p>
  </ApiLoading>
</template>

<script>
import { ApiLoading } from '@/components/index';

export default {
  name: 'MaintenanceMode',

  components: {
    ApiLoading,
  },

  props: {
    maintenanceModeMessage: {
      type: String,
      default: "Sorry, we're undergoing maintenance right now. Please try again in some time.",
    },
  },
};
</script>
